import styled from "styled-components";
import ReactSlider from "react-slider";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 2.2vh;
  align-items: center;

  .thumb-0 {
    font-size: 0 !important;
  }
`;

export const StyledSlider = styled(ReactSlider)`
  width: 100%;
  height: 11vh;
  display: flex;
  align-items: center;
`;

export const StyledThumb = styled.div`
  height: 10.4vh;
  width: 10.4vh;
  text-align: center;
  background-color: #5776ff;
  color: #5776ff;
  border-radius: 50%;
  cursor: grab;

  &:focus {
    outline: 0;
  }

  &:hover {
    background: #3f5ed1;
    height: 12vh;
    width: 12vh;
  }
`;

export const StyledTrack = styled.div`
  height: 1.2vh;
  background: ${(props) => (props.index === 1 ? "#c2c6da" : "#5776ff")};
  border-radius: 999px;
`;

export const CurrentValueText = styled.span`
  color: #5776ff;
  font-size: 12.38095238095238vh;
  text-align: center;
`;

export const NextButton = styled.div`
  border-radius: 5px;
  color: "white";
  border-radius: 17.02px;
  height: 13.026819923371647vh;
  width: 48%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  text-align: center;
  font-size: 5.363984674329502vh;
  margin-top: 4.1vh;
  background: ${(props) => (props.isDisabled ? "#92A7F4" : "#5776ff")};
  cursor: ${(props) => (props.isDisabled ? "not-allowed" : "pointer")};

  &:hover {
    background: ${(props) => (props.isDisabled ? "" : "#3f5ed1")};
  }
`;
